import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { SvgIconProps, Tooltip } from "@mui/material";
import { ReactNode } from "react";
import Flex, { FlexProps } from "./Flex";

interface InfoProps {
  children: ReactNode;
  iconProps?: SvgIconProps;
  FlexProps?: FlexProps;
  title: string;
  hideInfoIcon?: boolean;
}

const WithInfo = ({
  children,
  iconProps,
  FlexProps,
  title,
  hideInfoIcon = false,
}: InfoProps) => {
  return (
    <Flex gap={0.5} alignItems={"center"} {...FlexProps}>
      {children}

      {!hideInfoIcon && (
        <Tooltip title={title} placement="top" arrow style={{}}>
          <InfoOutlinedIcon fontSize="small" {...iconProps} />
        </Tooltip>
      )}
    </Flex>
  );
};

export default WithInfo;
